// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TeamMembersQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type TeamMembersQuery = { __typename?: 'Query', project: { __typename?: 'StandaloneProject', id: string, projectName: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } } | null | undefined }> } | { __typename?: 'Region', id: string, projectName: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } } | null | undefined }> } | { __typename?: 'Market', id: string, projectName: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } } | null | undefined }> } | { __typename?: 'Community', id: string, projectName: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } } | null | undefined }> } | { __typename?: 'Subdivision', id: string, projectName: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } } | null | undefined }> } | { __typename?: 'Lot', id: string, projectName: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } } | null | undefined }> } | { __typename?: 'Structure', id: string, projectName: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } } | null | undefined }> } | { __typename?: 'Unit', id: string, projectName: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } } | null | undefined }> } };

export type AvailableAssigneesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type AvailableAssigneesQuery = { __typename?: 'Query', project: { __typename?: 'StandaloneProject', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> } | { __typename?: 'Region', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> } | { __typename?: 'Market', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> } | { __typename?: 'Community', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> } | { __typename?: 'Subdivision', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> } | { __typename?: 'Lot', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> } | { __typename?: 'Structure', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> } | { __typename?: 'Unit', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> } };

export type UpdateProjectRoleMutationVariables = Types.Exact<{
  input: Types.UpdateProjectRoleInput;
}>;


export type UpdateProjectRoleMutation = { __typename?: 'Mutation', updateProjectRole: { __typename?: 'UpdateProjectRoleResult', tasks: Array<{ __typename?: 'Task', id: string, assignee?: { __typename?: 'InternalUser', id: string, email: string } | null | undefined }>, teamMember: { __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string } | null | undefined } } };

export type AvailableTeamMembersFragment = { __typename?: 'InternalUser', id: string, name: string, avatar: string };

export type TeamMemberFragment = { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string };

export type TeamMemberRoleFragment = { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string };

export const AvailableTeamMembersFragmentDoc = gql`
    fragment AvailableTeamMembers on InternalUser {
  id
  name
  avatar
}
    `;
export const TeamMemberFragmentDoc = gql`
    fragment TeamMember on InternalUser {
  id
  name
  avatar
  email
}
    `;
export const TeamMemberRoleFragmentDoc = gql`
    fragment TeamMemberRole on ProjectRoleDetail {
  code
  name
}
    `;
export const TeamMembersDocument = gql`
    query TeamMembers($projectId: ID!) {
  project(id: $projectId) {
    id
    projectName
    availableAssignees {
      ...AvailableTeamMembers
    }
    teamMembers {
      role {
        ...TeamMemberRole
      }
      user {
        ...TeamMember
        user {
          id
          isActive
        }
      }
    }
  }
}
    ${AvailableTeamMembersFragmentDoc}
${TeamMemberRoleFragmentDoc}
${TeamMemberFragmentDoc}`;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTeamMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables> & ({ variables: TeamMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
      }
export function useTeamMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export function useTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersSuspenseQueryHookResult = ReturnType<typeof useTeamMembersSuspenseQuery>;
export type TeamMembersQueryResult = Apollo.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const AvailableAssigneesDocument = gql`
    query AvailableAssignees($projectId: ID!) {
  project(id: $projectId) {
    id
    availableAssignees {
      ...AvailableTeamMembers
    }
  }
}
    ${AvailableTeamMembersFragmentDoc}`;

/**
 * __useAvailableAssigneesQuery__
 *
 * To run a query within a React component, call `useAvailableAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAssigneesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAvailableAssigneesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableAssigneesQuery, AvailableAssigneesQueryVariables> & ({ variables: AvailableAssigneesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableAssigneesQuery, AvailableAssigneesQueryVariables>(AvailableAssigneesDocument, options);
      }
export function useAvailableAssigneesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableAssigneesQuery, AvailableAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableAssigneesQuery, AvailableAssigneesQueryVariables>(AvailableAssigneesDocument, options);
        }
export function useAvailableAssigneesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableAssigneesQuery, AvailableAssigneesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableAssigneesQuery, AvailableAssigneesQueryVariables>(AvailableAssigneesDocument, options);
        }
export type AvailableAssigneesQueryHookResult = ReturnType<typeof useAvailableAssigneesQuery>;
export type AvailableAssigneesLazyQueryHookResult = ReturnType<typeof useAvailableAssigneesLazyQuery>;
export type AvailableAssigneesSuspenseQueryHookResult = ReturnType<typeof useAvailableAssigneesSuspenseQuery>;
export type AvailableAssigneesQueryResult = Apollo.QueryResult<AvailableAssigneesQuery, AvailableAssigneesQueryVariables>;
export const UpdateProjectRoleDocument = gql`
    mutation UpdateProjectRole($input: UpdateProjectRoleInput!) {
  updateProjectRole(input: $input) {
    tasks {
      id
      assignee {
        id
        email
      }
    }
    teamMember {
      role {
        ...TeamMemberRole
      }
      user {
        ...TeamMember
      }
    }
  }
}
    ${TeamMemberRoleFragmentDoc}
${TeamMemberFragmentDoc}`;
export type UpdateProjectRoleMutationFn = Apollo.MutationFunction<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>;

/**
 * __useUpdateProjectRoleMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRoleMutation, { data, loading, error }] = useUpdateProjectRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>(UpdateProjectRoleDocument, options);
      }
export type UpdateProjectRoleMutationHookResult = ReturnType<typeof useUpdateProjectRoleMutation>;
export type UpdateProjectRoleMutationResult = Apollo.MutationResult<UpdateProjectRoleMutation>;
export type UpdateProjectRoleMutationOptions = Apollo.BaseMutationOptions<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>;